import { render } from "./index.vue?vue&type=template&id=50707696"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/design/components/molecules/section/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "50707696"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('50707696', __exports__)) {
    api.reload('50707696', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=50707696", () => {
    api.rerender('50707696', render)
  })

}


export default __exports__